

export const PRICING = {
  monthly: 29,
  annual: 299,
  annualSavings: 49,
};

export const WALMART_PRICING = {
  monthly: '18.85',
  annual: '109',
  annualSavings: '117.20', // 12 x $18.85 - $109
};

export const INTRO_CHIPS = [
  { icon: 'lock', label: 'Secure & private' },
  { icon: 'cloud', label: 'Access anywhere' },
  { icon: 'home', label: 'Built for families' },
];

export const FOUR_PILLARS = [
  {
    num: '01',
    icon: 'prepare',
    title: 'Prepare',
    description: 'Create your family’s personalized emergency and disaster plan before you need it.',
  },
  {
    num: '02',
    icon: 'protect',
    title: 'Protect',
    description: 'Organize critical documents, family information, property records, inventories, pet info & more.',
  },
  {
    num: '03',
    icon: 'respond',
    title: 'Respond',
    description: 'Access emergency info and communication tools to help your family act quickly.',
  },
  {
    num: '04',
    icon: 'recover',
    title: 'Recover',
    description: 'Document damage, access important records and organize info needed to begin putting life back together.',
  },
];

export const PLAN_CHECKLIST = [
  'Family Emergency & Disaster Plan',
  'MYREDFOLDER® Family Chat & "I Need Help Now"',
  'Critical document storage (MY FILES)',
  'Property & home inventory',
  'MY PET Information',
  '“What My Family Needs to Know” vault',
  'Damage assessment & structural reports',
  'Emergency checklists & meeting locations',
];

export const PREMIUM_FEATURES_COLUMN3 = [
  {
    icon: 'plan',
    title: 'Family Emergency & Disaster Planning',
    description: 'Create personalized plans, meeting locations, evacuation routes and checklists.',
  },
  {
    icon: 'chat',
    title: 'Emergency Communication & Family Chat',
    description: 'Send emergency messages and stay connected when normal communication is disrupted.',
  },
  {
    icon: 'files',
    title: 'Access Critical Documents & MY FILES',
    description: 'Store and organize important documents and information in one secure location.',
  },
  {
    icon: 'property',
    title: 'MY Property(s) Inventory',
    description: 'Document your belongings with photos, purchase info, estimated value and more.',
  },
  {
    icon: 'damage',
    title: 'MYREDFOLDER® Damage Assessment Forms',
    description: 'Quickly and systematically document damage after an event.',
  },
  {
    icon: 'structural',
    title: 'MYREDFOLDER® Structural Analysis Report',
    description: 'Capture and organize structural information to support your recovery process.',
  },
  {
    icon: 'business',
    title: 'MY Business',
    description: 'Keep important business information organised and ready when you need it.',
  },
  {
    icon: 'pet',
    title: 'My Pet Information',
    description: 'Keep essential pet details, vet records, photos and emergency care instructions.',
  },
];
